var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2421 4.6395C14.2421 5.25352 14.0452 5.81985 13.7133 6.27433C13.7088 6.34801 13.6875 6.42273 13.6466 6.49368L12.08 9.20973C11.8876 9.54331 11.4062 9.54331 11.2138 9.20973L9.64724 6.49368C9.61781 6.44265 9.59852 6.38967 9.58834 6.33654C9.2282 5.87202 9.0127 5.28186 9.0127 4.6395C9.0127 3.14237 10.1833 1.92871 11.6274 1.92871C13.0715 1.92871 14.2421 3.14237 14.2421 4.6395ZM11.6274 6.74818C12.7506 6.74818 13.6611 5.80422 13.6611 4.63978C13.6611 3.47535 12.7506 2.53139 11.6274 2.53139C10.5042 2.53139 9.59372 3.47535 9.59372 4.63978C9.59372 5.80422 10.5042 6.74818 11.6274 6.74818Z",
    fill: "#00A651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15544 15.4283C5.15523 14.6571 5.01843 12.7335 6.31275 11.9568C8.24104 10.7997 10.2689 12.8897 12.0984 13.4997C13.2553 13.8854 14.7987 13.114 14.7984 11.9568C14.7982 10.7997 13.6413 9.64255 12.8699 9.25684",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.65118,
    cy: 9,
    r: 8.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelLight);
export default __webpack_public_path__ + "static/media/travel_light.f7f749d3aa6d37e39753bddc155dd90f.svg";
export { ForwardRef as ReactComponent };